import { CloudTestFeedbackType } from '@elementary/common-ui/services/gql/types';
import { FeedbackOption } from './types';

export const FEEDBACK_OPTION_TYPE: Record<
  Exclude<FeedbackOption, 'expected_change'>,
  CloudTestFeedbackType
> = {
  add_changepoint: 'EXPECTED_CHANGE_POINT',
  reduce_sensitivity: 'TEST_TOO_SENSITIVE',
  real_issue: 'REAL_ISSUE',
  add_context: 'CONTEXT',
};

export const FEEDBACK_OPTION_COPY: Record<
  FeedbackOption,
  { title: string; subtitle?: string; isAiPowered?: boolean }
> = {
  expected_change: {
    title: 'Expected change',
    subtitle: 'Suppress this failure.',
  },
  real_issue: {
    title: 'Real issue',
    subtitle: 'Do not train on new data until this is resolved.',
  },
  add_context: { title: 'Add more context' },
  add_changepoint: {
    title: 'Add a changepoint',
    subtitle: 'Treat this result as a one-time expected anomaly.',
  },
  reduce_sensitivity: {
    title: 'Reduce test sensitivity',
    subtitle: 'Do not alert on a change of this size in the future.',
    isAiPowered: true,
  },
};

export const RESULT_FEEDBACK_DIALOG_TITLE = 'Result feedback';
export const OPTIONS_STEP_TITLE = 'Choose what this result means.';
export const EXPECTED_CHANGE_STEP_TITLE =
  'How should this failure be suppressed?';
export const REAL_ISSUE_MESSAGE =
  "Marking a result as a real issue isn't available yet. We've noted your interest.";
export const CONTEXT_FIELD_TITLE = 'Context';
export const CONTEXT_PLACEHOLDER = 'What should we know about this result?';
export const CONTEXT_NOTE =
  "Your note is saved with this result. It won't change how the test runs for now.";
export const CHANGEPOINT_PROMPT = 'When did the level change?';
export const CONTEXT_SAVED_TOAST = 'Context saved.';
export const CHANGEPOINT_ADDED_TOAST = 'Changepoint added.';
export const CHANGEPOINT_RERUN_TOAST =
  'Changepoint added. The test is re-running, and the new result will be ready in a few minutes.';
export const EARLIER_ANOMALIES_NOT_COVERED_TOAST =
  "Earlier anomalies before this point aren't covered.";

export const REMOVE_CHANGEPOINT_CONFIRM_MESSAGE =
  'Remove this changepoint? The test will re-run without it.';
export const CHANGEPOINT_REMOVED_TOAST =
  'Changepoint removed. The test is re-running, and the new result will be ready in a few minutes.';

export const FEEDBACK_NOT_FOUND_ERROR_CODE = 175;

export const DEFAULT_FEEDBACK_ERROR_MESSAGE =
  'Something went wrong. Please try again.';
